import { connect } from "react-redux";
import * as R from "ramda";
import * as r from "recompose";
import { createStructuredSelector } from "reselect";
import { withRouter } from "react-router-dom";
import { fetchApi } from "core/api/hoc";
import * as twilio from "core/integrations/twilio";
import * as hoc from "modules/user/auth/hoc";
import { isOnboardedCandidate } from "modules/user/auth/model";
import * as bookingApi from "modules/booking/api";
import * as callingApi from "modules/calling/api";
import * as bookingSelectors from "modules/booking/selectors";
import * as callingSelectors from "modules/calling/selectors";
import { Loader } from "components/generic/kit";
import View from "./View";

export default r.compose(
  hoc.authorized(isOnboardedCandidate),
  withRouter,
  fetchApi(bookingApi.getBookingInfo, {
    key: "bookings",
    selector: bookingSelectors.getBookingInfoApi
  }),
  fetchApi(callingApi.createToken, ({ match }) => ({
    key: "setup",
    selector: callingSelectors.createTokenApi,
    payload: {
      bookingId: match.params.id
    }
  })),
  r.branch(
    r.compose(
      R.any(r.compose(R.isNil, R.prop("lastUpdated"))),
      R.values,
      R.pick(["bookings", "setup"])
    ),
    r.renderComponent(Loader)
  ),
  connect(
    createStructuredSelector({
      isNotCallTime: callingSelectors.isNotCallTime,
      info: bookingSelectors.getCurrentBookingInfo
    })
  ),
  r.withState("controls", "setControls", null),
  r.withState("status", "setStatus", "closed"),
  r.withState("pageReady", "setPageReady", false),
  r.lifecycle({
    componentDidMount() {
      const {
        setup,
        setControls,
        setStatus,
        setPageReady,
        isNotCallTime
      } = this.props;

      if (!isNotCallTime) {
        const { start, end } = twilio.init(setup.data, {
          onStatusChange: setStatus,
          onReady: () => {
            setControls({ start, end });
            setPageReady(true);
          },
          onOffline: console.log
        });
      } else {
        setPageReady(true);
      }
    },
    componentWillUnmount() {
      twilio.teardown();
    }
  }),
  r.branch(r.compose(R.not, R.prop("pageReady")), r.renderComponent(Loader))
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Call/Provider.js